var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHexagon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 83,
    viewBox: "0 0 95 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22394_198108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3101 4.72656H31.2344C28.1041 4.72656 25.1987 6.35308 23.5622 9.02157L6.67511 36.5586C4.91975 39.421 4.90377 43.0225 6.63368 45.9004L23.5675 74.0712C25.1949 76.7785 28.1224 78.4344 31.2811 78.4344H64.2635C67.4383 78.4344 70.3783 76.7617 72.0003 74.0325L88.7426 45.8613C90.4414 43.0028 90.4257 39.4405 88.7018 36.5971L72.006 9.06045C70.3747 6.36984 67.4566 4.72656 64.3101 4.72656Z",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    shapeRendering: "crispEdges",
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4399 9.19141H33.0516C30.2699 9.19141 27.6879 10.6364 26.233 13.0073L11.2588 37.4103C9.69694 39.9556 9.68273 43.1588 11.2219 45.7178L26.2429 70.6912C27.6897 73.0967 30.2914 74.5678 33.0984 74.5678H62.3933C65.2146 74.5678 67.8274 73.0817 69.2694 70.6568L84.1206 45.683C85.6321 43.1412 85.6181 39.9729 84.0842 37.4445L69.2796 13.0419C67.8293 10.6513 65.2361 9.19141 62.4399 9.19141Z",
    fill: "#FDFDFD",
    stroke: "url(#paint0_linear_22394_198108)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22394_198108",
    x: 0.847656,
    y: 0.226562,
    width: 93.6582,
    height: 82.707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.521826 0 0 0 0 0.135549 0 0 0 0 0.123008 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22394_198108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22394_198108",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22394_198108",
    x1: 8.7168,
    y1: 9.19141,
    x2: 73.1076,
    y2: 85.8774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F00707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70010E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon);
export default __webpack_public_path__ + "static/media/hexagon.16d389f0e3e14a3f7e813fe3cfc51586.svg";
export { ForwardRef as ReactComponent };